import React from 'react';
import { hashHistory } from 'react-router';

import xhr from './../../utils/xhr';
import utils from './../../utils/utilities';
import reduxStore from './../../reduxStore';

import Header from './../../reusable/Header/Header.index.jsx';
import Footer from './../../reusable/Footer/Footer.index.jsx';
import LoadingSpinner from './../../reusable/LoadingSpinner/LoadingSpinner.index.jsx';
import { FormattedMessage } from 'react-intl';

import actions from './../../api/Common.actions';
import storage from "../../utils/storage";


export default class LogoutPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showSpinner: true
        }
    }

    componentDidMount() {
        xhr.post({
            url: '/api/user/logout'
        }).then((response) => {
            if (response.ok) {

                reduxStore.dispatch(
                    {
                        type: 'USER_LOGOUT_SUCCESS'
                    }
                );
                utils.clearUserSession();
            }
        }).catch((error) => {
            utils.logError(error, "Fail to log out");
            reduxStore.dispatch(
                {
                    type: 'USER_LOGOUT_FAIL'
                }
            );
        }).then(()=>{
            return Promise.all(actions.loadPageMeta())
        }).then(()=>{
            let auth = storage.getObject("lnei");

            if (auth && auth.authInfo && auth.authInfo.type === "WAM") {
                if (this.props.location.query.redirect == "true") {
                    // redirect to WAM
                    window.location = auth.serverInfo.wamLogout + "&redirecturl=" + encodeURIComponent(auth.serverInfo.customerUi) + "&lnsi=" + auth.authInfo.lnsi;
                }
                this.setState({showSpinner: false});
            } else {
                hashHistory.push('/login');
            }
        }).catch((error) => {
            utils.logError(error, "reloading UI state failed");
            let auth = storage.getObject("lnei");

            if (auth && auth.authInfo && auth.authInfo.type === "WAM") {
                // redirect to WAM
                window.location = auth.serverInfo.wamLogout + "&redirecturl=" + encodeURIComponent(auth.serverInfo.customerUi) + "&lnsi=" + auth.authInfo.lnsi;
            } else {
                hashHistory.push('/login');
            }
        });
    }

    render() {
        return (
            <div className='app-wrapper'>
                <LoadingSpinner fixedSpinner={this.state.showSpinner} isVisible={this.state.showSpinner}/>
                <Header disableMenu />
                <div className='app-content-wrapper'>
                    <h1>
                        {!this.state.showSpinner ? <FormattedMessage id="General_CoreFunctionality_Error_error.LogoutMessage"/> : null}
                    </h1>
                </div>
                <Footer version={reduxStore.getState().header.version} />
            </div>
        );
    };

}



// WEBPACK FOOTER //
// ./src/scripts/pages/LogoutPage/LogoutPage.index.jsx